import { instance } from '../../config/intercepter';

export const getCompanyGroupsFn = async ({ queryKey }) => {
    const [
        ,
        { length = '25', search = '', page = 1 },
      ] = queryKey;
    const response = await instance.get(`api/companyGroups?length=${length}&search=${search}&page=${page}`);
    return response.data;
};

export const getCompanyGroupFieldsFn = async () => {
    const response = await instance.get(`api/companyGroups/create`);
    return response.data;
}

export const getCompanyGroupByIdFn = async (groupId) => {
    const response = await instance.get(`api/companyGroups/${groupId}`);
    return response.data;
};

export const impersonateFleetAdminFn = async (userid) => {
    const response = await instance.post(`/api/companyGroups/impersonate/${userid}`, {"userId":userid});
    return response.data;
  };

export const assignMembersToGroupFn = async(groupId, payload) => {
    const response = await instance.post(`/api/companyGroups/${groupId}/assign`, payload)
    return response.data;
}

export const unassignMembersToGroupFn = async(groupId, payload) => {
    const response = await instance.post(`/api/companyGroups/${groupId}/unassign`, payload)
    return response.data;
}

export const createShadowUserFn = async(payload) => {
    const response = await instance.post(`/api/companyGroups/userCreate`, payload)
    return response.data;
}

export const addCompanyGroupFn = async (payload) => {
    const response = await instance.post(`api/companyGroups`, payload);
    return response.data;
};

export const getCompanyGroupEditableFieldsFn = async (groupId) => {
    const response = await instance.get(`api/companyGroups/${groupId}/edit`);
    return response.data;
}

export const updateGroupByIdFn = async (groupId, payload) => {
    const response = await instance.put(`/api/companyGroups/${groupId}`, payload);
    return response.data;
};

export const deleteGroupByIdFn = async (groupId) => {
    const response = await instance.delete(`api/companyGroups/${groupId}`);
    return response.data;
};